module.exports = __webpack_public_path__ + "img/Convertible_Back_Side_Left.13a4fb67.svg";